import { EventRepository } from '~repositories/EventRepository';
import { events, query, serviceQueries } from '@estee/elc-service-bus';
import serviceNames from '~setup/AnalyticsService';
import { diContainer } from '~setup/diContainer';
import { Event } from '~entities/Event';
import { mapProductSkusById } from '../../utils/dataAggregator';
import { ISkuData } from './ProductNotifyMeTriggeredUseCase';

export class QuickViewUseCase {
    private eventRepository: EventRepository;
    private skuId: string;
    // eslint-disable-next-line  @typescript-eslint/no-explicit-any
    private product: any;

    // eslint-disable-next-line  @typescript-eslint/no-explicit-any
    constructor(skuId: string, product?: any) {
        this.eventRepository = diContainer.get(serviceNames.eventRepository);
        this.skuId = skuId;
        this.product = product;
    }

    public execute = async () => {
        let productInfo = this.product;
        if (!productInfo) {
            // TODO: we shouldn't need to call this twice
            // eslint-disable-next-line  @typescript-eslint/no-explicit-any
            const data = <any>await query(serviceQueries.GET_PRODUCT_DATA, {
                filterBy: { skus: { skuIds: [this.skuId] } }
            });
            const skuIdMap: ISkuData = data.reduce(mapProductSkusById, {});

            productInfo = skuIdMap[this.skuId];
        }
        if (!productInfo) {
            console.warn(`QuickViewUseCase: No product found for skuId ${this.skuId}`);

            return;
        }
        // TODO: figure out a way to deal with productInfo here so that it can be done in DataAggregator
        const quickViewPayload = {
            enh_action: 'detail',
            event_action: 'product detail view - quickview',
            event_category: 'ecommerce',
            event_label: `PROD${productInfo.product_id || productInfo.productId}`,
            event_name: 'quickview',
            event_noninteraction: 'FALSE',
            product_product_code: `${productInfo.productCode || productInfo.skuId}`
        };

        const productShortPayload = {
            product: this.product,
            skuId: this.skuId
        };

        const newEvent = new Event({
            id: this.eventRepository.generateId(),
            name: events.QUICK_VIEW_TRIGGERED,
            type: 'link',
            payload: quickViewPayload,
            data: {
                productShort: productShortPayload
            }
        });

        this.eventRepository.addEventToQueue(newEvent);
    };
}
